export default "__VITE_ASSET__Bz6R11IA__"